export default value => value / 1.19;